
import { useState } from 'react';
import { ClaimRequest, ClaimRequestActionProps } from './ClaimRequestInterface';
import EmptyClaimRequests from './EmptyClaimRequests';
import PendingClaimRequestCard from './PendingClaimRequestCard';

interface PendingClaimsTabProps extends ClaimRequestActionProps {
  requests: ClaimRequest[];
  isLoading: boolean;
}

const PendingClaimsTab = ({ 
  requests, 
  isLoading, 
  onApprove,
  onReject 
}: PendingClaimsTabProps) => {
  return (
    <div className="space-y-4">
      {isLoading || requests.length === 0 ? (
        <EmptyClaimRequests isLoading={isLoading} type="pending" />
      ) : (
        requests.map(request => (
          <PendingClaimRequestCard 
            key={request.id}
            request={request} 
            onApprove={onApprove}
            onReject={onReject}
          />
        ))
      )}
    </div>
  );
};

export default PendingClaimsTab;
